import { useState, useEffect, useRef } from 'react'
import logo from '../../assets/newlogo.png'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import useCurrentUserProfile from '../../hooks/useCurrentUserProfile';
import useMarketPlaceVerificationStatus from '../../hooks/useMarketPlaceVerificationStatus';
import MarketPlaceNotifications from './MarketPlaceNotifications';
import useNotifications from '../../hooks/useNotifications';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketPlaceFeedNavbar = () => {
  const bellRef = useRef(null);
  const { notifications, unreadCount, setUnreadCount } = useNotifications();
  const {isVerified}=useMarketPlaceVerificationStatus()
  const [searchTerm, setSearchTerm] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "feed";
  const searchType =  searchParams.get("type");
  const navigate = useNavigate()
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const modalRef = useRef(null);
  const {profile} = useCurrentUserProfile()
  const token = localStorage.getItem("access_token");
  const [open, setOpen] = useState(false);
  // console.log("The searchresults are:",searchResults)
   useEffect(() => {
      function handleClickOutside(e) {
        if (bellRef.current && !bellRef.current.contains(e.target)) {
          setOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

  useEffect(() => {
    if (!searchTerm || searchTerm.trim() === "") return;
    const fetchSearchResults = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/marketplace/researcher/feed/search?q=${searchTerm}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
              'x-api-key': process.env.REACT_APP_X_API_KEY,
            },
          }
        );
        //  console.log("The response is:",response.data)
        setSearchResults(response.data)
      } catch (error) {
        console.log("Error while search:", error)
      }
    }
    fetchSearchResults()
  }, [searchTerm])
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsProfileDropdownOpen(false);
      }
    };
    if (isProfileDropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isProfileDropdownOpen]);

  const logout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

const markAllNotificationsRead = async (notificationsArray) => {
    if (!notificationsArray || notificationsArray.length === 0) return;
    const unreadIds = notificationsArray
      .filter((n) => !n.is_read)
      .map((n) => n.id);

    if (unreadIds.length === 0) return;

    try {
      await Promise.all(
        unreadIds.map((id) =>
          axios.patch(
            `${BASE_URL}/user/chat/notification/`,
            { notification_id: id },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                "Content-Type": "application/json",
                "x-api-key": process.env.REACT_APP_X_API_KEY
              },
            }
          )
        )
      );
      console.log("All notifications marked as read");
    } catch (error) {
      console.error("Error marking notifications as read:", error);
    }
  };
const handleNavigate = async () => {
  try {
    // setLoading(true);

    const res = await fetch(`${BASE_URL}/marketplace/verification-status`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_X_API_KEY,
      },
    });

    const data = await res.json();

    if (data?.is_verified === true && data?.verification_type === "researcher") {
      navigate("/marketplace/independent_researcher/dashboard");
    } 
    else if (data?.is_verified === true && data?.verification_type === "university") {
      navigate("/marketplace/university");
    } 
    else if (data?.is_verified === true && data?.verification_type === "industry") {
      navigate("/marketplace/industry");
    } 
    else if (data?.is_verified === true && data?.verification_type === "dean") {
      navigate(`/marketplace/${data?.universityName}/dean`, {
        state: { id: data?.university_id },
      });
    } 
    else if (data?.is_verified === true && data?.verification_type === "labhead") {
      navigate(
        `/marketplace/${data?.universityName}/${data?.dean_name}/${data?.department_name}/lab/labhead`,
        {
          state: {
            id: data?.university_id,
            dean_id: data?.dean_id,
            department_id: data?.department_id,
            lab_id: data?.profile_id,
            profile_id: data?.profile_id,
            user_id: data?.user_id,
          },
        }
      );
    } 
    else if (data?.is_verified === true && data?.verification_type === "manager") {
      navigate("/marketplace/industry/manager");
    } 
    else if (data?.is_verified === true && data?.verification_type === "assistant_manager") {
      navigate("/marketplace/industry/manager/assistant_manager");
    } 
    else {
      navigate("/marketplace");
    }
  } catch (err) {
    console.error(err);
    navigate("/marketplace");
  } 
  // finally {
  //   setLoading(false);
  // }
};

  return (
    <nav className="hidden md:block w-full  flex items-center justify-center transition-all duration-300 sticky top-0 z-[999] px-6 py-4 bg-white border-b border-gray-100 shadow-sm ">
      <div className="w-full max-w-[1920px] mx-auto flex justify-between items-center gap-6">
        {/* Logo Section */}
        <div className="flex items-center gap-4 w-full max-w-[35%]">
          <div className="cursor-pointer">
            <img
              src={logo}
              className="w-full h-16  object-contain"
              alt="Logo"
              onClick={(e) => navigate(-1 )}
            />
          </div>
        </div>
        <div className="w-full max-w-[30%] relative" >
          <div className="relative">
            <input
              type="search"
              className="w-full px-5 py-3 pr-12 bg-white outline-none text-sm rounded-xl border border-gray-300 text-gray-900 placeholder:text-gray-400 hover:border-gray-400 focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              placeholder="Search for research, journals, people, etc."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value)
              }}
            />
            <div
              className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 flex items-center justify-center cursor-pointer"
            >
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>
          {searchTerm.trim() && searchResults.length > 0 && (
            <div className="absolute top-full mt-2 left-0 right-0 bg-white rounded-xl shadow-lg border border-gray-200 max-h-80 overflow-y-auto z-20">
              <div className="p-2">
                {searchResults.map((user) => (
                  <div
                    key={user.id}
                    className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => {
                      setSearchResults([]);
                      setSearchTerm("")
                       navigate(`/marketplace/search?search=${user?.name}`);
                    }}
                  >
                    <div className="relative">
                      <img
                        src={user?.profile_data?.profile_picture}
                        alt={user?.profile_data?.name}
                        className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                      />
                      <div
                        className={`absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full border border-white ${user?.profile_data?.is_online ? 'bg-green-500' : 'bg-gray-400'
                          }`}
                      />

                    </div>
                    <div>
                      <p className="font-medium text-gray-900 text-sm">{user.name}</p>
                      <p className="text-xs text-gray-500">By: {user?.university_name ? user?.university_name : 'Researcher'}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* )}


              {/* Right Side Actions */}
        {/* ref={profileRef} */}
        <div className="flex justify-end items-center gap-4 max-w-[35%] !important" >
          {/* {!hideBell && profile && ( */}
          <>
            {/* ref={bellRef} */}
            <div style={{ position: "relative" }} ref={bellRef}>
              <button
                 onClick={async () => {
                  setOpen(!open);
                  if (!open) {
                    await markAllNotificationsRead(notifications);
                    setUnreadCount(0);
                  }
                }}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
               {unreadCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                    {unreadCount}
                  </span>
                )}
              </button>
               {open && <MarketPlaceNotifications onReadAll={()=>setUnreadCount(0)} />}
            </div>

            <div>
              <button
                onClick={() => navigate("/marketplace/chat")}
                className="relative w-10 h-10 bg-[#e8f0f7] flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
              >
                <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                {/* {totalUnreadMessages > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-semibold w-5 h-5 flex items-center justify-center rounded-full">
                  {totalUnreadMessages} 0
                </span> */}
              
              </button>
            </div>
          </>
          <ul className="flex gap-4 list-none items-center w-max">
            <li className="cursor-pointer" onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}>
              <div className="w-12 h-12 flex justify-center items-center rounded-full p-1 overflow-hidden border-2 border-gray-50 hover:border-[#0f6abf] transition-colors">
                <img
                  src={profile?.profile_picture || "https://via.placeholder.com/64"}
                  alt="User"
                  className="w-full h-full object-cover"
                />
              </div>
            </li>
          </ul>
          {/* && profile */}
          {isProfileDropdownOpen && (
            <div ref={modalRef} className="absolute top-16 right-6 bg-white rounded-xl shadow-lg border border-gray-200 w-64 py-2 backdrop-blur-lg z-[1000]">
              <div className="p-2">
                <div
                  // to='/marketplace/independent_researcher/dashboard'
                  onClick={handleNavigate}
                  className="flex items-center gap-3 px-4 py-3 cursor-pointer rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                >
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span className="text-sm font-medium">{isVerified ? 'Your Dashboard' : 'Join Marketplace'}</span>
                </div>
                <Link
                  to="/home"
                  className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700"
                >
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.5 7h13L17 13M7 13H5.4M17 13l1.5 7M6 21a1 1 0 100-2 1 1 0 000 2zm12 0a1 1 0 100-2 1 1 0 000 2z"
                    />
                  </svg>
                  <span className="text-sm font-medium">Axionnest</span>
                </Link>

                <div className="border-t border-gray-200 mt-2 pt-2">
                  <div
                    className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-50 transition-colors text-gray-700 cursor-pointer"
                    onClick={logout}
                  >
                    <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    <span className="text-sm font-medium">Log out</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </nav>
  )
}

export default MarketPlaceFeedNavbar